module.exports = __webpack_public_path__ + "img/xeicon.ac63bd15.svg";